const SuppliesCategoryComponent = () => import('@/views/office/SuppliesCategory/SuppliesCategoryView')

export default [
    {
        path:'/SuppliesCategoryIndex',
        name:'SuppliesCategoryComponent',
        component:SuppliesCategoryComponent
    }
]